import React from 'react'
import {
  useIsBasketWithFixedShippingPrice,
  useConfigState,
  useLocalLabels,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { BasketLabels } from '../../basket.props'

import { DeliveryText } from '../../../Common'

export const FreeShippingLabel = ({
  totalPrice,
  ...rest
}: {
  totalPrice: number
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  const isWithFixedShippingPrice = useIsBasketWithFixedShippingPrice()
  const config = useConfigState()
  const labels = useLocalLabels<BasketLabels>()
  const allLabels = useGlobalLabels()

  if (isWithFixedShippingPrice) {
    return (
      <div {...rest}>
        <DeliveryText>{labels?.fixedDeliveryPrice}</DeliveryText>
      </div>
    )
  }

  if (config.freeShippingPrice < totalPrice) {
    return (
      <div {...rest}>
        <DeliveryText>{allLabels?.freeDelivery}</DeliveryText>
      </div>
    )
  }

  const difference = config.freeShippingPrice - totalPrice

  return (
    <div {...rest}>
      <DeliveryText>
        {`${labels?.freeDeliverySentence?.start} ${difference.toFixed(2)}${
          labels?.freeDeliverySentence?.middlePart
        } `}
        <strong>{labels?.freeDeliverySentence?.end}</strong>!
      </DeliveryText>
    </div>
  )
}
